
import Base from "@/common/Base.vue";

export default {
  extends: Base,

  props: {
    products: {
      type: Array,
      required: false,
      default() {
        return [];
      },
    },
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
    empty: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
};
